import React, { useMemo, useState } from 'react';

import { useResponsiveRange } from '../../../../hooks/useResponsiveRange';

import EyeIcon from '../../../../design-system/Icons/EyeIcon';
import ViewOnlyNestedItemModal from '../ViewOnlyNestedItemModal/ViewOnlyNestedItemModal';
import { ButtonIcon } from '../../../../design-system';

// setting in format saved on the backend (not saved in the form data)
// additional prop can be added if the format saved in form data needed
const ViewOnlyNestedInput = ({ setting }) => {
    const {
        label,
        value,
        details: { item_name, properties },
        placeholder,
    } = setting;

    const [inputRef, columnNumber] = useResponsiveRange([0, 450, 790, 1100, 1500, 1900]);
    const [modalItem, setModalItem] = useState(null);

    const itemName = item_name || label;

    const isEmptyValue = !value || !value?.length;

    const firstStringPropertyName = useMemo(
        () => properties?.find(({ type }) => type === 'string')?.name,
        [properties]
    );

    const emptyValueMessage = `No ${label} added yet.`;

    return (
        <div className="flex flex-col gap-1.5" ref={inputRef}>
            {!isEmptyValue && columnNumber !== null && (
                <div
                    className="grid gap-2"
                    style={{ gridTemplateColumns: `repeat(${columnNumber}, minmax(0, 1fr))` }}
                >
                    {value.map((item, index) => (
                        <div
                            key={index}
                            className="w-full h-[140px] min-h-[140px] rounded-2 border-1 border-neutral-200 p-3 flex flex-col gap-1 overflow-hidden bg-white"
                        >
                            <div className="flex items-center justify-between">
                                <p className="font-body-bold text-body-bold-xs text-neutral-300 uppercase">
                                    {itemName} {index + 1}
                                </p>
                                <ButtonIcon
                                    type="link"
                                    size="xs"
                                    icon={EyeIcon}
                                    onClick={() => setModalItem(item)}
                                />
                            </div>
                            <p className="font-heading-bold text-heading-bold-s text-neutral-500 line-clamp-3">
                                {item[firstStringPropertyName] || `${itemName} ${index + 1}`}
                            </p>
                        </div>
                    ))}
                </div>
            )}

            {isEmptyValue && (
                <div className="w-full h-[140px] min-h-[140px] p-4 overflow-hidden rounded-[10px] bg-purple-100 border-1 border-dashed border-purple-500 flex items-center justify-center">
                    <p className="font-body text-body-regular-s text-neutral-300 text-center">
                        {placeholder || emptyValueMessage}
                    </p>
                </div>
            )}

            {modalItem && (
                <ViewOnlyNestedItemModal
                    item={modalItem}
                    itemName={itemName}
                    properties={properties}
                    onClose={() => setModalItem(null)}
                />
            )}
        </div>
    );
};

export default ViewOnlyNestedInput;
